var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('vue-snotify'),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"}),_c('div',{},[_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-10 offset-md-1 mb-4",domProps:{"innerHTML":_vm._s(_vm.viewData)}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }